import type { ReportData } from './tokens/types';

export type FetchStatus = 'idle' | 'loading' | 'ready' | 'error';

export type SourceKey =
    | 'assesseeBasic'
    | 'unifiedOverview'
    | 'score'
    | 'mainOverview'
    | 'relatedParties'
    | 'shareholding'
    | 'fundingHistory'
    | 'mcaDocs'
    | 'gstr1'
    | 'gstr3b'
    | 'epf'
    | 'compliancesHeadline'
    | 'auditedFinancials'
    | 'legalCases'
    | 'amlPep'
    | 'alerts'
    | 'orgInfo'
    | 'insightsOverview'
    | 'insightsCompliance'
    | 'insightsLegalChecks'
    | 'insightsAuditedFinancials'
    | 'insightsRelatedParty'
    | 'auditedStatements'
    | 'mcaCharges'
    | 'provisionalStatements'
    | 'bankingCashflow'
    | 'bankingOverview'
    | 'directorsDeep';

export type UseAicaReportData = {
    status: FetchStatus;
    data: ReportData;
    errors: Partial<Record<SourceKey, string>>;
    refetch: () => void;
};

export const OVERVIEW_METRICS = [
    'Revenue',
    'RevenueGrowthPercentage',
    'EbitaMargin',
    'PAT',
    'CashAndCashEquivalent',
    'TotalCurrentAssets',
    'TotalCurrentLiabilities',
    'NetWorkingCapital',
    'LongTermDebt',
    'ShortTermDebt',
    'TangibleNetWorth',
];

export const INSIGHT_MODULE_IDS = [
    { moduleId: 'OVERVIEW', key: 'insightsOverview' },
    { moduleId: 'COMPLIANCE', key: 'insightsCompliance' },
    { moduleId: 'LEGAL_CHECKS', key: 'insightsLegalChecks' },
    { moduleId: 'AUDITED_FINANCIALS', key: 'insightsAuditedFinancials' },
    { moduleId: 'RELATED_PARTY', key: 'insightsRelatedParty' },
] as const satisfies ReadonlyArray<{ moduleId: string; key: SourceKey }>;
